import React from 'react';
import { Link } from 'react-router-dom';

// Small X Logo for Footer
const XLogoSmall = ({ className = "w-8 h-8" }) => (
  <svg viewBox="0 0 40 40" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="40" rx="10" fill="url(#logoGradientFooter)"/>
    <path 
      d="M12 12L20 20M20 20L28 28M20 20L28 12M20 20L12 28" 
      stroke="white" 
      strokeWidth="3" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient id="logoGradientFooter" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
        <stop stopColor="#002699"/>
        <stop offset="1" stopColor="#E62020"/>
      </linearGradient>
    </defs>
  </svg>
);

const Footer = () => {
  return (
    <footer 
      data-testid="footer"
      className="relative py-8 sm:py-12 bg-gray-900 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 sm:gap-6">
          {/* Copyright */}
          <div className="flex items-center gap-2 sm:gap-3">
            <Link to="/">
              <XLogoSmall className="w-7 sm:w-8 h-7 sm:h-8 hover:scale-110 transition-transform duration-300" />
            </Link>
            <span className="text-xs sm:text-sm text-gray-400">
              © 2026 Xerobrain Labs
            </span>
          </div>

          {/* Links */}
          <div className="flex items-center gap-4 sm:gap-8">
            <Link
              to="/privacy"
              className="text-xs sm:text-sm text-gray-400 hover:text-white hover:-translate-y-0.5 transition-all duration-300"
            >
              Privacy
            </Link>
            <Link
              to="/terms"
              className="text-xs sm:text-sm text-gray-400 hover:text-white hover:-translate-y-0.5 transition-all duration-300"
            >
              Terms
            </Link>
            <Link
              to="/contact"
              className="text-xs sm:text-sm text-gray-400 hover:text-white hover:-translate-y-0.5 transition-all duration-300"
            >
              Contact
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
